export default "__VITE_ASSET__r5W2tR8n__"